import { AffiliateClientsResponse } from '@avanzu/types';
import {
  Box,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PaperSection from '../../components/PaperSection';
import { apiClient } from '../../services/apiClient';
import formatDate, { DateFormatOptions } from '../../utils/formatDate';

const ClientsPage: React.FC = () => {
  const [clients, setClients] = useState<AffiliateClientsResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await apiClient.get('/affiliate/clients');
        if (response.ok) setClients(await response.json());
      } catch (err) {
        console.error('Failed to load clients:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <PaperSection title="Referred clients">
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Organisation</TableCell>
              <TableCell>Linked</TableCell>
              <TableCell>First paid project</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!clients || clients.clients.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Typography variant="body2" color="text.secondary" sx={{ py: 4 }}>
                    No referred organisations yet — share your referral link to get started
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              clients.clients.map((client) => (
                <TableRow key={client.organisationId}>
                  <TableCell>{client.orgName}</TableCell>
                  <TableCell>{formatDate(client.linkedAt, DateFormatOptions.DATEONLY)}</TableCell>
                  <TableCell>
                    <Chip
                      label={client.hasPaidProject ? 'Yes' : 'Not yet'}
                      size="small"
                      color={client.hasPaidProject ? 'success' : 'default'}
                    />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {clients && clients.total > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {clients.total} referred organisation{clients.total !== 1 ? 's' : ''}
        </Typography>
      )}
    </PaperSection>
  );
};

export default ClientsPage;
